import { Pagination } from "@mui/material";
import { useEffect, useState } from "react";
// import { transactions } from "../../Utils/data";
import {
  ArchiveIcon,
  CalendarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { NavLink } from "react-router-dom";
import { checkTagValidity } from "../../Utils/Utils";
import {
  EN_ATTENTE_IDENTIFICATION,
  EN_ATTENTE_LIVRAISON,
  EN_ATTENTE_PAIEMENT,
  EN_ATTENTE_RENDEZ_VOUS,
  LIST_INTENTION,
} from "../../Utils/constant";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { useIntentionStore } from "../../store/intentionStore";
import { Pbo } from "../Widget/Pbo";
import { Periode } from "../Widget/Periode";

export const Abonnement = ({ status, step, perm }) => {
  const intentions = useIntentionStore();
  const [indelay, setIndelay] = useState();

  const enAttente = (inTime, page, param, size) => {
    intentions.intentionListEnAttente(
      status === "EN_ATTENTE_DE_PAIEMENT"
        ? EN_ATTENTE_PAIEMENT
        : status === "EN_ATTENTE_DE_PROVISIONING"
          ? LIST_INTENTION
          : status === "EN_ATTENTE_DE_LIVRAISON"
            ? EN_ATTENTE_LIVRAISON
            : status === "EN_ATTENTE_DE_RENDEZ_VOUS_DE_RACCORDEMENT"
              ? EN_ATTENTE_RENDEZ_VOUS
              : status === "EN_ATTENTE_DE_RENDEZ_VOUS"
                ? EN_ATTENTE_RENDEZ_VOUS
                : EN_ATTENTE_IDENTIFICATION,
      { page: page ?? 0, param: param ?? ``, size: size ?? 8 },
      `&inTime=${inTime ?? null}${
        status === "EN_ATTENTE_DE_RENDEZ_VOUS_DE_RACCORDEMENT"
          ? "&typeRdv=RACCORDEMENT"
          : status === "EN_ATTENTE_DE_RENDEZ_VOUS"
            ? "&typeRdv=SURVEY"
            : "&statusSuppression=&date=&isActive=&sousMenu=&status=EN_ATTENTE_DE_PROVISIONING"
      }`,
    );
  };

  useEffect(() => {
    enAttente();
  }, [status]);

  const more = (page) => {
    enAttente(indelay, page - 1);
  };

  return (
    <>
      <div className="mt-3 lg:flex items-center gap-1">
        <input
          onChange={(e) => enAttente("", 0, e.target.value, 8)}
          type="text"
          placeholder="Rechercher element..."
          className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
        />
        <select
          onChange={(e) => enAttente(e.target.value)}
          className="select pl-non my-3"
        >
          <option disabled selected>
            Delais de traitement
          </option>
          <option value="">Tout afficher</option>
          <option value={"true"}>Intention dans le delais</option>
          <option value={"false"}>Intention hors delais</option>
        </select>
      </div>

      <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 xl:grid-cols-3 mt-4 grid-cols-1 gap-5">
        {intentions?.data?.data?.length === 0 ? (
          <div className="">
            <p className="text-sm ">Aucune donnée</p>
          </div>
        ) : intentions?.data?.data?.length !== 0 && !intentions?.loading ? (
          intentions?.data?.data?.map((item) => (
            <div
              className={`${
                !item?.inTime
                  ? "border-red-300 border-2"
                  : "border-slate-200 border"
              } ${
                item?.statusSuppression === "EN_ATTENTE" && "opacity-30"
              } relative bg-white rounded-xl  shadow-sm`}
            >
              <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                <p className="text-[12px] font-semibold">
                  N° {item?.numeroTicket}
                </p>
                <p className="text-red-500 text-xs">
                  {!item?.inTime ? "Hors delais" : ""}
                </p>
                <div className="ml-auto flex items-center gap-2">
                  <div
                    className={` px-1 border  rounded-full py-[2px] text-xs ${
                      item?.statusConfirmation === "CONFIRMER"
                        ? "text-green-600"
                        : "text-gray-500"
                    }  font-semibold`}
                  >
                    {item?.statusConfirmation
                      ?.toLowerCase()
                      .replace("_", " ")
                      .replace("er", "é")}
                  </div>
                </div>
              </div>
              <div className=" px-3 py-2 ">
                <div className="items-center gap-2 space-y-3">
                  <Periode item={item} />
                  <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                  <div className="flex gap-1 my-3">
                    <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                    <div>
                      <p className="text-[13px] font-medium">
                        {item?.client?.nomPrenoms}
                      </p>
                      <p className="text-xs flex font-semibold gap-2">
                        <span>{item?.client?.numero}</span> {" | "}{" "}
                        <span>{item?.client?.secondNumero}</span>{" "}
                      </p>
                    </div>
                  </div>
                  <h1 className="text-xs flex gap-1 items-center my-2">
                    Forfait : {item?.forfait?.designation} -{" "}
                    {item?.forfait?.categorie?.replace("_", " ").toLowerCase()}
                  </h1>
                  {status === "EN_ATTENTE_DE_SURVEY" ||
                  status === "EN_ATTENTE_DE_RACCORDEMENT" ? (
                    <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                      <p className="text-xs flex gap-1 items-center font-medium">
                        <CalendarIcon />
                        {status === "EN_ATTENTE_DE_SURVEY"
                          ? item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY",
                            )?.date +
                            " de " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY",
                            )?.crenau?.heureDebut +
                            " à " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "SURVEY",
                            )?.crenau?.heureFin
                          : item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT",
                            )?.date +
                            " de " +
                            item?.listRendezVous.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT",
                            )?.crenau?.heureDebut +
                            " à " +
                            item?.listRendezVous?.find(
                              (e) => e.typeRendezVous === "RACCORDEMENT",
                            )?.crenau?.heureFin}
                      </p>
                    </div>
                  ) : null}

                  <div className=" gap-1 ">
                    <div>
                      {item?.numeroFtth && (
                        <p className="text-[13px] font-medium">
                          Numero FTTH : {item?.numeroFtth}
                        </p>
                      )}

                      {item?.PIID && (
                        <p className="text-[13px] font-medium">
                          PID: PI{item?.PIID}
                        </p>
                      )}

                      {item?.numeroSerie && (
                        <p className="text-xs flex font-semibold gap-2">
                          SN : <span>{item?.numeroSerie}</span>
                        </p>
                      )}

                      {item?.status === "EN_ATTENTE_DE_IDENTIFICATION" && (
                        <div className="flex items-center gap-2">
                          <p className="text-[13px] font-medium">
                            Agent : {item?.agent?.nomPrenoms}
                          </p>{" "}
                          |
                          <p className="text-xs flex font-semibold gap-2">
                            <span>{item?.agent?.numero}</span>
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                    <p className="text-xs flex gap-1 items-center font-medium">
                      <HomeIcon />
                      {item?.batiment?.designation}
                    </p>
                    <p className="text-xs flex gap-1 font-medium">
                      <ArchiveIcon /> {item?.equipement?.designation}{" "}
                    </p>
                  </div>
                </div>
                <h1 className="my-2 text-[13px] font-medium flex items-center">
                  <SewingPinFilledIcon />
                  {item?.commune + ", " + item?.quartier}
                </h1>
                <div className="flex items-center gap-1">
                  <h5 className="text-xs font-medium ">Etape:</h5>
                  <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                    {item?.status?.toLowerCase().replace(/_/g, " ")}
                  </p>
                </div>

                {checkTagValidity(perm) &&
                item?.statusSuppression !== "EN_ATTENTE" ? (
                  item?.status === "EN_ATTENTE_DE_PROVISIONING" ? null : (
                    <NavLink
                      className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                      to={`poursuivre-intention/${item?.numeroTicket}/${step}`}
                    >
                      Poursuivre
                    </NavLink>
                  )
                ) : null}
              </div>
            </div>
          ))
        ) : (
          <ContentLoading />
        )}
      </div>
      <div className="my-3 flex justify-end">
        <Pagination
          onChange={(event, newValue) => more(newValue)}
          onSelect={(selectedPage) => more(selectedPage)}
          count={intentions?.data?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </div>
    </>
  );
};
